import AbstractCRUDService from './AbstractCRUDService';
import IVehicleType from '../models/IVehicleType';

class VehicleService extends AbstractCRUDService<IVehicleType> {}

export default new VehicleService('logistics/vehicle_type');
